import Vue from 'vue'

/**
 * TYPE=0: unwanted error, show message immediately
 * TYPE=1: error that only the server can know
 * TYPE=2: error that requires redirect or handle specifically
 */
var appCode = {

	// Error message for all system
	message: '',

	// Common
	'1': { type: 0, value: 'データが正しくありません。' },
	'2': { type: 0, value: 'データが正しくありません。' },
	'3': { type: 0, value: 'データが正しくありません。' },
	'4': { type: 0, value: 'リクエストに失敗しました。' },
	'10': { type: 0, value: 'サーバーエラーが発生しました。' },
	'11': { type: 0, value: 'メール送信に失敗しました。' },
	'12': { type: 0, value: 'メール送信に失敗しました。' },
	'13': { type: 0, value: 'メール送信に失敗しました。' },
	'14': { type: 0, value: 'メール送信に失敗しました。' },

	// url-error
    '21': { type: 0, value: '不正なURLです。'},
    '22': { type: 0, value: 'URLの有効期限が切れています。'},
    '23': { type: 0, value: 'こちらのアンケートは回答済みです。'},
    '24': { type: 1, value: 'こちらの求人は回答済みです。'},
	'25': { type: 0, value: 'こちらの面接は面接日程確定済みまたは再調整中です。'},

	//口コミレビュー
	'2901': { type: 0, value: '口コミ投稿は受領済みです。' },

	// 面接日程選択
	'3001': { type: 0, value: '申し訳ございません。<br>選択された日時で面接を組むことが出来ませんでした。<br>別の面接日時を選択してください。' },
	'3002': { type: 0, value: 'こちらの面接は現在、日程の再調整を行っております。<br>面接日程を再度回収出来ましたら<br>改めてご連絡いたします。' },
}

Vue.use({
	install(Vue, options) {
		Vue.prototype['$appCode'] = appCode
	}
})

export default appCode



// WEBPACK FOOTER //
// ./src/services/app-code.js